// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCQEz64cEsVvELqwhia7eQAD56yiamtLB8",
  authDomain: "nice2-store.firebaseapp.com",
  projectId: "nice2-store",
  storageBucket: "nice2-store.firebasestorage.app",
  messagingSenderId: "593767414030",
  appId: "1:593767414030:web:bd056173233fda905fff5f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Export services
export { db, auth, storage }; 